/**
 * The component for col in FormBuilder
 *
 * This wraps col with configuration icons, it also display an empty placeholder if no children is present.
 *
 */
import React from "react";
import { injectIntl } from "react-intl";
import FormLabel from "../FormLabel";
import styled from "styled-components";
import { FakeCol, StyledEmptyColumnPlaceholder } from "./styled";

const Relative = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  margin-top: ${(p) => (p.marginTop ? "60px" : 0)};
`;

const AddButton = styled.button`
  padding-bottom: 4px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  background-color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  font-size: 24px;
  color: #777;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
  border-radius: 10px;

  &:focus {
    outline: none;
  }
`;

const SettingsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  left: 10px;
  bottom: 10px;
  background-color: #fff;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 20px;
  color: #777;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);

  transition: opacity 150ms ease;

  &:hover {
    background-color: #efefef;
  }

  &:focus {
    outline: none;
  }
`;

const MoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  left: 10px;
  bottom: 10px;
  background-color: #fff;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 20px;
  color: #777;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);

  transition: opacity 150ms ease;

  &:hover {
    background-color: ${(p) => p.theme.colors.danger};
    color: ${(p) => p.theme.colors.on.danger};
  }

  &:focus {
    outline: none;
  }
`;

const RemoveButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  left: 10px;
  bottom: 10px;
  background-color: #fff;
  border: none;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  font-size: 20px;
  color: #777;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);

  transition: opacity 150ms ease;

  &:hover {
    background-color: ${(p) => p.theme.colors.danger};
    color: ${(p) => p.theme.colors.on.danger};
  }

  &:focus {
    outline: none;
  }
`;

const RepeatWrapper = styled.div`
  border: 4px dashed ${(p) => p.theme.colors.secondary};
  border-radius: 10px;
  padding-bottom: 100px;
  padding-right: 10px;
  padding-left: 10px;
  background: white !important;
`;

const RepeatLabel = styled.div`
  margin-top: 12px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Btns = styled.div`
  display: flex;

  & > button {
    margin-left: 10px;
  }

  z-index: 2000;
`;

// used if we have no children to create some space to put new components in
const EmptyColumnPlaceholder = ({
  id,
  DropZone,
  fb3ClickMove,
  moveMode,
  select,
}) => {
  return (
    <StyledEmptyColumnPlaceholder>
      {moveMode ? (
        <DropZone
          className="fal fa-clone"
          onClick={(e) => {
            e.stopPropagation();
            fb3ClickMove({ src: moveMode, dst: id });
          }}
        />
      ) : (
        <Relative>
          <AddButton
            data-id={id}
            data-mode="add"
            data-position="center"
            data-overlayposition="absolute"
            onClick={select}
          >
            +
          </AddButton>
        </Relative>
      )}
    </StyledEmptyColumnPlaceholder>
  );
};

// This is an empty column

const RepeatEdit = (props) => {
  const {
    extra = {},
    children = [],
    select,
    id,
    selected,
    theme = {},
    intl,
    remove,
    parentId,
  } = props;
  const { style = {}, label } = extra;
  const { col = {} } = theme;

  return (
    <RepeatWrapper
      inlineStyle={{ ...col, ...style }}
      warning={children.length == 0}
      className={``}
      hover={true}
    >
      <RepeatLabel>
        <div>{intl.formatMessage({ id: "Repeat" })}</div>
        <Btns>
          <MoveButton
            data-id={id}
            data-parentid={parentId}
            data-position="center"
            data-place="top"
            data-overlayposition="absolute"
            onClick={(e) => {
              e.stopPropagation();
              props.move({ id });
            }}
          >
            <em className="fal fa-sign-in-alt" />
          </MoveButton>
          <RemoveButton
            data-id={id}
            data-parentid={parentId}
            data-position="center"
            data-place="top"
            data-overlayposition="absolute"
            onClick={remove}
          >
            <em className="fal fa-trash" />
          </RemoveButton>
          <SettingsButton
            data-parentid={parentId}
            data-id={id}
            data-position="center"
            data-place="top"
            data-overlayposition="absolute"
            onClick={select}
          >
            <em className="fal fa-cog" />
          </SettingsButton>
        </Btns>
      </RepeatLabel>
      {label && <FormLabel extra={{ label }} />}
      {children.length == 0 ? (
        <EmptyColumnPlaceholder {...props} />
      ) : (
        <FakeCol hoverConfig={selected} inlineStyle={style}>
          {children}
        </FakeCol>
      )}
    </RepeatWrapper>
  );
};

export default injectIntl(RepeatEdit);
